import { Component } from '@angular/core';

@Component({
    selector: 'logo',
    template: `
        <img fxHide.lt-sm src="/images/logo.png" style="height: 30px;">
        <img fxHide.gt-xs src="/images/logo-small-ff.png" style="height: 30px; margin-top: 10px;">
    `
})
export class LogoComponent {
}
